import React from "react";
import { useHistory  ,NavLink } from "react-router-dom";
// import { useNavigate   ,NavLink } from 'react-router-dom';
import { isEnterPress } from "../../../utils/helpers/accessibilityUtil";
import HeaderItemProps from "./HeaderItemProps";

const HeaderItem = (props: HeaderItemProps) => {
  //const history = useHistory();
  const [imageSrc, setImageSrc] = React.useState(props.image);

  React.useEffect(() => {
    if (isActivePath()) {
      setImageSrc(props.greenImage);
    }
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (isActivePath()) {
      setImageSrc(props.greenImage);
    } else {
      setImageSrc(props.image);
    }
    // eslint-disable-next-line
  }, [props.activePath]);

  const isActivePath = () => {
    return props.activePath === props.path;
  };

  const mouseEnterHandler = (e: any) => {
    if (!isActivePath()) {
      setImageSrc(props.greenImage);
    }
  };

  const mouseLeaveHandler = (e: any) => {
    if (!isActivePath()) {
      setImageSrc(props.image);
    }
  };

  return (
    <NavLink
      id={`header-center-item-${props.alt}`}
      className={props.cssClass ? props.cssClass : "header-center-item"}
      //onClick={() => history.push(props.path)}
      to={props.path}
      //onKeyPress={(event) => isEnterPress(event) && history.push(props.path)}
      tabIndex={0}
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
    >

      <img width={24} height={24} className="header-center-icon" src={imageSrc} alt={props.alt} role="presentation" aria-hidden="true" />
      <span className="header-center-text">{props.text}</span>
    </NavLink>
  );
};

export default HeaderItem;
